import React, { useEffect } from 'react';
import toastr from 'toastr';
import "./Login.css";
import sha1 from 'crypto-js/sha1';
import CircularProgress from '@material-ui/core/CircularProgress';
import { buildOktaAuthClient, readOktaConfig, clearOktaConfig } from "../auth/oktaConfig";
import { APP_NAME, AuthenticateOktaUrl } from '../constants/apiUrls';

export function LoginOkta(props) {
    useEffect(() => {
        const config = readOktaConfig();
        if (!config) {
            document.location.href = "/";
            return;
        }

        const oktaAuth = buildOktaAuthClient(config);

        const run = async () => {
            try {
                if (oktaAuth.isLoginRedirect()) {
                    await oktaAuth.handleLoginRedirect();
                }

                const idToken = oktaAuth.getIdToken();
                if (!idToken) {
                    clearOktaConfig();
                    document.location.href = "/";
                    return;
                }

                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ token: idToken, appName: APP_NAME })
                };

                const response = await fetch(AuthenticateOktaUrl(), requestOptions);
                const data = await response.json();

                if (!response.ok) {
                    for (var i = 0; i < (data.errors || []).length; i++) {
                        toastr.error(data.errors[i]);
                    }
                    sessionStorage.clear();
                    await oktaAuth.tokenManager.clear();
                    clearOktaConfig();
                    setTimeout(function () {
                        document.location.href = "/";
                    }, 1000);
                    return;
                }

                var authorizationToken = sha1(data.uniqueKey + "qMymank8Q0rNyJ0RxDXE");
                props.loginCallback(data.uniqueKey, authorizationToken.toString());
            } catch (e) {
                console.log(e);
                clearOktaConfig();
                document.location.href = "/";
            }
        };

        run();
    }, []);

    return (
        <div className="Login">
            <div className="text-center">
                <img src="/logo_vertical.svg" className="logo" />
            </div>
            <form className="my-4" >
                <div className="text-center">
                    <CircularProgress />
                </div>
            </form>
        </div>
    );
}
